import { ActivitySubTypeId } from '../domain';
import { AppSettings } from '../app-settings';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { WidgetsModule } from './../widgets/widgets.module';
// Components
import { AppComponent } from './app.component';
import { StatusBannerComponent } from './status-banner/status-banner.component';
import { ProjectListComponent } from './project-list/project-list.component';
import { ProjectDetailComponent } from './project-detail/project-detail.component';
import { NonANRCollaboratorModalComponent } from '../widgets/non-anr-collaborator-modal/non-anr-collaborator-modal.component';
import { ActivitiesComponent } from './activities/activities.component';
import { ActivityEditorComponent } from './activity-editor/activity-editor.component';
import { ActivityEditorModalComponent } from './activity-editor-modal/activity-editor-modal.component';
import { AcademicComponent } from './academic/academic.component';
import { AuthGuardService } from './auth-guard.service';
import { NoProxyGuardService } from './no-proxy-guard.service';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { NewActivityModalComponent } from './new-activity-modal/new-activity-modal.component';
import { ProjectModalComponent } from './project-modal/project-modal.component';
import { ClienteleComponent } from './clientele/clientele.component';
import { ThemesComponent } from './themes/themes.component';
import { FteComponent } from './fte/fte.component';
import { ClienteleGroupModalComponent } from './clientele-group-modal/clientele-group-modal.component';
import { CountyFteModalComponent, MultiStateProjectModalComponent, ConditionChangeFteModalComponent }  from './fte/modals/';
import * as Shims from '../shims';
import { NewThemeModalComponent } from './new-theme-modal/new-theme-modal.component';

import { ReviewAndCompileComponent } from './review-and-compile/review-and-compile.component';
import { MyPbDataComponent as ReviewAndCompileMyPbDataComponent}from './review-and-compile/my-pb-data/my-pb-data.component';
import { ThemesComponent as ReviewAndCompileThemesComponent } from './review-and-compile/my-pb-data/themes/themes.component';
import { ActivitiesComponent as ReviewAndCompileActivitiesComponent } from './review-and-compile/my-pb-data/activities/activities.component';
import { MyDirectReportsComponent as ReviewAndCompileMyDirectReportsComponent } from './review-and-compile/my-direct-reports/my-direct-reports.component';
import { MySupervisorsComponent as ReviewAndCompileMySupervisorsComponent } from './review-and-compile/my-supervisors/my-supervisors.component';

import { UcDeliversStoryLinkComponent } from './uc-delivers-story-link/uc-delivers-story-link.component';
import { ConsoleService } from '../widgets/console.service';
import * as D from '../domain';
import { UserPreferenceComponent } from './user-preference/user-preference.component';
import { ActivityTypeMenuModalComponent } from '../widgets/activity-type-menu-modal/activity-type-menu-modal.component';
import { ActivityModalService } from './activity-modal.service';
import { ProfileComponent } from './profile/profile.component';
import { AcademicProfessionalAssociationComponent } from './academic-professional-association/academic-professional-association.component';
import { ExploreWhatsHappeningComponent } from './explore-whats-happening/explore-whats-happening.component';
import { UserRolesSwitchComponent } from './user-roles-switch/user-roles-switch.component';
import { AHRComponent } from './ahr/ahr.component';
import { ActivityCollaborationConfirmationModalComponent } from './activity-collaboration-confirmation-modal/activity-collaboration-confirmation-modal.component';
import { CRCComponent } from './crc/crc.component';
import { AHROnboardingModalComponent } from './ahr-onboarding-modal/ahr-onboarding-modal.component';
import { ProjectModalService } from './project-modal.service';
import { SectionHeaderComponent } from './section-header/section-header.component';
import { DefaultLoggedInUserComponent } from './default-logged-in-user/default-logged-in-user.component';
import { AuthenticationModalComponent } from './authentication-modal/authentication-modal.component';
import { CaseModalComponent } from './ahr/case-modal/case-modal.component';
import { ReviewStepsEditorComponent } from './ahr/review-steps-editor/review-steps-editor.component';
import { CaseListComponent, CaseStatePipe } from './ahr/case-list/case-list.component';
import { ActionTypeNamePipe } from './ahr/action-type-name.pipe';
import { TitleRankStepTermPipe } from './ahr/title-rank-step-term.pipe';
import { NewsStoryListComponent } from './ahr/news-story-list/news-story-list.component';
import { AHRWrapperComponent } from './ahr/ahr-wrapper/ahr-wrapper.component';
import { PositionFilterComponent } from './ahr/position-filter/position-filter.component';
import { ReviewerCommitteesComponent } from './ahr/reviewer-committees/reviewer-committees.component';
import { SelectUserModalComponent } from './select-user-modal/select-user-modal.component';
import { AcademicCaseListComponent } from './ahr/academic-case-list/academic-case-list.component';
import { AcademicCaseDetailComponent } from './ahr/academic-case-detail/academic-case-detail.component';
import { ProgressionTableWorkshopModalComponent } from './ahr/progression-table-workshop-modal/progression-table-workshop-modal.component';
import { ReviewRequirementsWorkshopModalComponent } from './ahr/review-requirements-workshop-modal/review-requirements-workshop-modal.component';
import { ProgressionTableComponent } from './ahr/progression-table/progression-table.component';
import { AdvancementSelectorModalComponent } from './ahr/advancement-selector-modal/advancement-selector-modal.component';
import { NewAcademicModalComponent } from './ahr/new-academic-modal/new-academic-modal.component';
import { HtmlContentModalComponent } from './html-content-modal/html-content-modal.component';
import { AcademicReportSubmissionComponent } from './academic-report-submission/academic-report-submission.component';
import { PdfviewerModalComponent } from './pdfviewer-modal/pdfviewer-modal.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { AHRSettingsComponent } from './ahr-settings/ahr-settings.component';
import { AHRSettingsWrapperComponent } from './ahr-settings/ahr-settings-wrapper/ahr-settings-wrapper.component';
import { AHRReviewDatesComponent } from './ahr-settings/ahr-review-dates/ahr-review-dates.component';
import { AHRTestClockComponent } from './ahr-settings/ahr-test-clock/ahr-test-clock.component';
import { TestClockModalComponent } from './test-clock-modal/test-clock-modal.component';
import { NotificationsWrapperComponent } from './notifications/notifications-wrapper/notifications-wrapper.component';
import { NotificationLogComponent } from './notifications/notification-log/notification-log.component';
import { NotificationTemplatesComponent } from './notifications/notification-templates/notification-templates.component';
import { NotificationMessageModalComponent } from './notifications/notification-message-modal/notification-message-modal.component';
import { NotificationRequeueModalComponent } from './notifications/notification-requeue-modal/notification-requeue-modal.component';
import { TemplateDiffModalComponent } from './notifications/notification-templates/template-diff-modal/template-diff-modal.component';
import { TimeServedTableComponent } from './ahr/time-served-table/time-served-table.component';
import { ReviewerDashboardComponent } from './program-review/reviewer-dashboard/reviewer-dashboard.component';
import { ReviewerMyReviewComponent } from './program-review/reviewer-my-review/reviewer-my-review.component';
import { ReviewerCaseDetailComponent } from './program-review/reviewer-case-detail/reviewer-case-detail.component';
import { CaseProgressBarComponent } from './program-review/case-progress-bar/case-progress-bar.component';
import { StageStepperComponent } from './program-review/stage-stepper/stage-stepper.component';
import { CaseFilesComponent } from './program-review/case-files/case-files.component';
import { ReviewerCaseListComponent, ReviewerCaseNotSelected } from './program-review/reviewer-case-list/reviewer-case-list.component';
import { GoogleAnalyticsService } from './google-analytics.service';
import { TooltipService } from '../widgets/tooltip.service';
import { TermTableComponent } from './ahr/term-table/term-table.component';
import { ProposedActionComponent } from './ahr/proposed-action/proposed-action.component';
import { DossierExportDataModalComponent } from 'app/widgets/dossier-export-data/dossier-export-data-modal.component';

import { MsalBroadcastService, MsalGuardConfiguration, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent, MsalService, MSAL_INSTANCE } from '@azure/msal-angular';
import { InteractionType, IPublicClientApplication, PublicClientApplication  } from '@azure/msal-browser';
import { SpoofUserComponent } from './admin/spoof-user/spoof-user.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';

import { OktaAuthModule, OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { CustomOktaCallbackComponent } from './custom-okta-callback/custom-okta-callback.component';
import { AuthenticationType } from '../domain';

// Workflow Components
import { AprLandingComponent } from './program-review/landing/apr-landing.component';
import { MyTasksComponent } from './program-review/workflow/my-tasks/my-tasks.component';
import { TaskFormComponent } from './program-review/workflow/task-form/task-form.component';
import { PacketDetailComponent } from './program-review/workflow/packet-detail/packet-detail.component';
import { CaseReviewDateOverridesComponent } from './program-review/workflow/case-review-date-overrides/case-review-date-overrides.component';
import { UnsavedChangesGuard } from './program-review/workflow/unsaved-changes.guard';
import { AllCasesComponent } from './program-review/workflow/all-cases/all-cases.component';
import { showMaintenanceScreen } from './maintenance-screen';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

Shims.ObjectKeysShim();
Shims.ObjectValuesShim();

export const APP_INITIALIZER_DEPS = [
	AppSettings,
	D.AppVersionService,
	D.ActivityService,
	D.ClienteleService,
	D.FTEService,
	D.AHRService,
	ConsoleService,
	TooltipService
];

function delay(ms: number): Promise<void> {
	return new Promise(resolve => setTimeout(resolve, ms));
}

function waitForBackend(apiUrl: string, maxAttempts: number, delayMs: number): Promise<void> {
	const healthUrl = apiUrl + '/version';
	let attempt = 0;
	const check = (): Promise<void> =>
		fetch(healthUrl).then(resp => {
			/* 503 is maintenance, not a slow start: retrying gains nothing, and the
			** returned promise must never settle so Angular does not bootstrap the app
			** underneath the banner. The banner polls for recovery on its own. */
			if (resp.status === 503) {
				showMaintenanceScreen(apiUrl);
				return new Promise<void>(() => { });
			}
			if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
			return;
		}).catch(() => {
			attempt++;
			if (attempt >= maxAttempts) throw new Error(`Backend not available after ${maxAttempts} attempts`);
			console.warn(`Backend not ready, retrying in ${delayMs / 1000}s... (${maxAttempts - attempt} attempts left)`);
			return delay(delayMs).then(check);
		});
	return check();
}

export function APP_INITIALIZER_FACTORY(
	appSettings: AppSettings,
	appVersionSvc: D.AppVersionService,
	activitySvc: D.ActivityService,
	clienteleSvc: D.ClienteleService,
	fteSvc: D.FTEService,
	ahrService: D.AHRService,
	consoleService: ConsoleService,
	tooltipSevice: TooltipService
){
	return () => {
		consoleSVC = consoleService;
		console.log('APP_INITIALIZER started...');
		return appSettings.init()
			.then(_ => waitForBackend(appSettings.APIURL, 10, 3000))
			.then(_ => Promise.all([
				appVersionSvc.config(),
				activitySvc.config(),
				clienteleSvc.config(),
				fteSvc.config(),
				ahrService.config()
			]))
			.then(
				_ => {

					msalConfig.auth.clientId = appSettings.WFAClientId;
					msalConfig.auth.authority = appSettings.WFAAuthority + appSettings.WFATenantId;
					msalConfig.auth.redirectUri = appSettings.WFARedirectUri;

					tooltipSevice.init();
					consoleService.init(appSettings.enableConsoleLogging);

					consoleSVC = consoleService;
					console.log('...APP_INITIALIZER finished.');
				},
				err => {
					console.error('...APP_INITIALIZER FAILED', err);
					if (err && err.status === 503) {
						/* The maintenance gate is on and this client has no bypass. Render the static
						** banner in place — keeping the current URL, mirroring what the IIS rewrite
						** does for fresh navigations. The returned promise deliberately never
						** settles: resolving would count as successful init and let Angular bootstrap
						** the app (login UI and all) underneath the banner. */
						showMaintenanceScreen(appSettings.APIURL);
						return new Promise<void>(() => { });
					}
					alert('Something went wrong.\nAttempting to re-initialize by reloading your browser window...')
					window.location.reload();
				});
	};
}

let msalConfig: any = {
	auth: {
		clientId: '', // This is your Application ID
		authority: '', // 'Cloud_instance_ID'/'Tenant_Info' this is your tenant ID
		redirectUri: '',// This is your redirect URI
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
	}
};

let consoleSVC: ConsoleService;

export function MSALInstanceFactory(): IPublicClientApplication {
	consoleSVC.log('initializing MSALInstanceFactory instance');
	consoleSVC.log('msalconfig: ', msalConfig);
	return new PublicClientApplication({
		auth: msalConfig.auth,
		cache: msalConfig.cache,
		/*
		system: {
			loggerOptions: {
			loggerCallback,
			logLevel: LogLevel.Info,
			piiLoggingEnabled: false
			}
		}*/
	});
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
	consoleSVC.log('initializing MSALInterceptorConfigFactory instance');
	const protectedResourceMap = new Map<string, Array<string>>();
  	protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
	protectedResourceMap.set('api://db5009ab-297d-4e1b-bb49-52eef780148d/api_user_access', ['api://api_user_access']);
	consoleSVC.log(protectedResourceMap);

	return {
		interactionType: InteractionType.Popup,
		protectedResourceMap: protectedResourceMap
	};
}
  
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
	consoleSVC.log('initializing MSALGuardConfigFactory instance');
	return {
		interactionType: InteractionType.Popup,
		authRequest: {
			scopes: ['user.read']
		},
		loginFailedRoute: '/login-failed'
	};
}

export function oktaConfigFactory(appSettings: AppSettings): any {

	if (!appSettings.OktaIssuer) {
        consoleSVC.log('Okta issuer not configured, creating disabled OktaAuth instance.');
        return {
            oktaAuth: new OktaAuth({
                issuer: 'https://disabled-okta.local',
                clientId: 'disabled-client',
                redirectUri: window.location.origin,
                scopes: ['openid', 'profile', 'email']
            })
        };
    }

	const config = {
		issuer: appSettings.OktaIssuer,
		clientId: appSettings.OktaClientId,
		redirectUri: appSettings.OktaRedirectUri,
		scopes: ['openid', 'profile', 'email']
	};

	consoleSVC.log('Okta config:', config);

	return { oktaAuth: new OktaAuth(config) };
}

export const routes: Routes = [
	{
		path: '',
		component: UserRolesSwitchComponent,
		canActivate: [AuthGuardService],
		children: [
			{
				path: 'ahr',
				component: AHRWrapperComponent,
				canActivate: [AuthGuardService],
				children: [
					{
						path: '',
						redirectTo: 'cases',
						pathMatch: 'full'
					},
					{
						path: 'cases',
						component: CaseListComponent
					},
					{
						path: 'committees',
						component: ReviewerCommitteesComponent
					},
					{
						path: 'news',
						component: NewsStoryListComponent
					},
					{
						path: 'settings',
						component: AHRSettingsWrapperComponent,
						children: [
							{
								path: '',
								redirectTo: 'program-year-open',
								pathMatch: 'full'
							},
							{
								path: 'program-year-open',
								component: AHRSettingsComponent
							},
							{
								path: 'review-dates',
								component: AHRReviewDatesComponent,
								canDeactivate: [UnsavedChangesGuard]
							},
							{
								path: 'test-clock',
								component: AHRTestClockComponent
							}
						]
					},
					{
						path: 'notifications',
						component: NotificationsWrapperComponent,
						children: [
							{
								path: '',
								redirectTo: 'log',
								pathMatch: 'full'
							},
							{
								path: 'log',
								component: NotificationLogComponent
							},
							{
								path: 'templates',
								component: NotificationTemplatesComponent
							}
						]
					}
				]
			},
			{
				path: 'ahr_old',
				component: AHRComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'program-review/:yearId',
				component: AcademicCaseListComponent,
				children: [
					{
						path: ':yearId',
						component: AcademicCaseDetailComponent
					}
				]
			},
			{
				path: 'program-review',
				component: AcademicCaseListComponent,
				children: [
					{
						path: ':yearId',
						component: AcademicCaseDetailComponent
					}
				]
			},
			{
				path: 'review',
				component: ReviewerDashboardComponent,
				canActivate: [NoProxyGuardService],
				children: [
					{
						path: '',
						redirectTo: 'home',
						pathMatch: 'full'
					},
					{ path: 'home', component: AprLandingComponent },
					{
						path: 'my-review',
						component: ReviewerMyReviewComponent,
						data: {autoSelectFirstCase: false},
						children: [
							{
								path: ':caseId',
								component: ReviewerCaseDetailComponent,
							},
							{
								path: '',
								component: ReviewerCaseNotSelected
							}
						]
					},
					{ path: 'my-tasks', component: MyTasksComponent },
					{ path: 'my-cases', component: AllCasesComponent, data: { mode: 'mine' } },
					{ path: 'all-cases', component: AllCasesComponent, data: { mode: 'all' } },
					{ path: 'task/:taskId', component: TaskFormComponent },
						{ path: 'packet/:caseId', component: PacketDetailComponent, canDeactivate: [UnsavedChangesGuard] },
				]
			},
			{
				path: 'admin-proxy',
				component: SpoofUserComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'academic',
				component: AcademicComponent,
				canActivate: [AuthGuardService],
				children: [
					{
						path: '',
						redirectTo: 'themes',
						pathMatch: 'full'
					},
					{
						path: 'fte',
						component: FteComponent
					},
					{
						path: 'fte/project/:editProjectId',
						component: FteComponent
					},
					{
						path: 'clientele',
						component: ClienteleComponent
					},
					{
						path: 'themes',
						component: ThemesComponent
					},
					{
						path: 'explore',
						component: ExploreWhatsHappeningComponent
					},
					{
						path: 'review-and-compile',
						component: ReviewAndCompileComponent,
						children: [
							{
								path: '',
								redirectTo: 'my-pb-data/themes', //This is ultimately going to depend on user permissions
								pathMatch: 'full'
							},
							{
								path: 'my-pb-data',
								component: ReviewAndCompileMyPbDataComponent,
								children: [
									{
										path: 'themes',
										component: ReviewAndCompileThemesComponent
									},
									{
										path: 'university-and-public-service',
										component: ReviewAndCompileActivitiesComponent,
										data: { activitySubTypeId: [ActivitySubTypeId.UniversityService, ActivitySubTypeId.PublicService] }
									},
									{
										path: 'professional-competences',
										component: ReviewAndCompileActivitiesComponent,
										data: { activitySubTypeId: [ActivitySubTypeId.EvidenceOfProfessionalCompetence, ActivitySubTypeId.ProfessionalDevelopmentAndTraining] }
									}
								]
							},
							{
								path: 'my-direct-reports',
								component: ReviewAndCompileMyDirectReportsComponent
							},
							{
								path: 'my-supervisors',
								component: ReviewAndCompileMySupervisorsComponent
							}
						]
					},
					{
						path: 'preferences',
						component: UserPreferenceComponent
					},
					{
						path: 'profile',
						component: ProfileComponent
					},
					{
						path: 'projects',
						component: ProjectListComponent
					},
					{
						path: 'projects/:id',
						component: ProjectDetailComponent
					},
					{
						path: 'activities',
						component: ActivitiesComponent
					},
					{
						path: 'activities/:id',
						component: ActivitiesComponent
					}
				]
			},
			{
				path: 'crc',
				component: CRCComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'explore',
				component: DefaultLoggedInUserComponent,
				canActivate: [AuthGuardService]
			}
		],
	},
	{
		path: 'login/callback',
		component: CustomOktaCallbackComponent
	},
	{
		path: 'login',
		component: AuthenticationComponent
	}
];

@NgModule({
	bootstrap: [MsalRedirectComponent],
	exports: [
		WidgetsModule,
		CountyFteModalComponent,
		ConditionChangeFteModalComponent,
		ActionTypeNamePipe,
		TitleRankStepTermPipe,
	],
	imports: [
		CommonModule,
		FormsModule,
		WidgetsModule,
		BrowserModule,
		HttpClientModule,
		ReactiveFormsModule,
		MatButtonToggleModule,
		MatExpansionModule,
		MatInputModule,
		RouterModule.forRoot(routes, {useHash: false}),
		MsalModule,
		OktaAuthModule
	],
	declarations: [
		AppComponent,
		StatusBannerComponent,
		ProjectListComponent,
		ProjectDetailComponent,
		ActivitiesComponent,
		ActivityEditorComponent,
		ActivityEditorModalComponent,
		AcademicComponent,
		AHRComponent,
		AuthenticationComponent,
		AuthenticationModalComponent,
		CRCComponent,
		UserMenuComponent,
		NewActivityModalComponent,
		ProjectModalComponent,
		ClienteleComponent,
		ThemesComponent,
		FteComponent,
		ClienteleGroupModalComponent,
		CountyFteModalComponent,
		ConditionChangeFteModalComponent,
		NewThemeModalComponent,
		ReviewAndCompileComponent,
		ReviewAndCompileMyPbDataComponent,
		ReviewAndCompileActivitiesComponent,
		ReviewAndCompileThemesComponent,
		ReviewAndCompileMySupervisorsComponent,
		ReviewAndCompileMyDirectReportsComponent,
		UcDeliversStoryLinkComponent,
		UserPreferenceComponent,
		ProfileComponent,
		AcademicProfessionalAssociationComponent,
		ExploreWhatsHappeningComponent,
		UserRolesSwitchComponent,
		ActivityCollaborationConfirmationModalComponent,
		CRCComponent,
		AHROnboardingModalComponent,
		MultiStateProjectModalComponent,
		SectionHeaderComponent,
		DefaultLoggedInUserComponent,
		CaseModalComponent,
		ReviewStepsEditorComponent,
		CaseListComponent,
		ActionTypeNamePipe,
		TitleRankStepTermPipe,
		NewsStoryListComponent,
		AHRWrapperComponent,
		PositionFilterComponent,
		ReviewerCommitteesComponent,
		SelectUserModalComponent,
		CaseStatePipe,
		AcademicCaseListComponent,
		AcademicCaseDetailComponent,
		ProgressionTableWorkshopModalComponent,
		ReviewRequirementsWorkshopModalComponent,
		ProgressionTableComponent,
		AdvancementSelectorModalComponent,
		NewAcademicModalComponent,
		HtmlContentModalComponent,
		AcademicReportSubmissionComponent,
		PdfviewerModalComponent,
		AHRSettingsComponent,
		AHRTestClockComponent,
		TestClockModalComponent,
		AHRSettingsWrapperComponent,
		AHRReviewDatesComponent,
		NotificationsWrapperComponent,
		NotificationLogComponent,
		NotificationTemplatesComponent,
		NotificationMessageModalComponent,
		NotificationRequeueModalComponent,
		TemplateDiffModalComponent,
		TimeServedTableComponent,
		ReviewerDashboardComponent,
		ReviewerMyReviewComponent,
		ReviewerCaseDetailComponent,
		CaseProgressBarComponent,
		StageStepperComponent,
		CaseFilesComponent,
		ReviewerCaseListComponent,
		ReviewerCaseNotSelected,
		TermTableComponent,
		ProposedActionComponent,
  		SpoofUserComponent,
		DossierExportDataModalComponent,
 		CustomOktaCallbackComponent,
		MyTasksComponent,
		AprLandingComponent,
		TaskFormComponent,
		PacketDetailComponent,
		CaseReviewDateOverridesComponent,
		AllCasesComponent
	],
	entryComponents: [
		ActivityCollaborationConfirmationModalComponent,
		ActivityEditorModalComponent,
		ActivityTypeMenuModalComponent,
		AHROnboardingModalComponent,
		AuthenticationModalComponent,
		NewAcademicModalComponent,
		NewActivityModalComponent,
		NewThemeModalComponent,
		ProjectModalComponent,
		ClienteleGroupModalComponent,
		CountyFteModalComponent,
		MultiStateProjectModalComponent,
		ConditionChangeFteModalComponent,
		NonANRCollaboratorModalComponent,
		SelectUserModalComponent,
		CaseModalComponent,
		ProgressionTableWorkshopModalComponent,
		ReviewRequirementsWorkshopModalComponent,
		AdvancementSelectorModalComponent,
		HtmlContentModalComponent,
		PdfviewerModalComponent,
		ReviewerDashboardComponent,
		DossierExportDataModalComponent
	],
	providers: [
		ActivityModalService,
		AuthGuardService,
		NoProxyGuardService,
		AppSettings,
		GoogleAnalyticsService,
		ConsoleService,
		ProjectModalService,
		ActionTypeNamePipe,
		TitleRankStepTermPipe,
		TooltipService,	
		{
			provide: APP_INITIALIZER,
			useFactory: APP_INITIALIZER_FACTORY,
			deps: APP_INITIALIZER_DEPS,
			multi: true
		},
		{
			provide: MSAL_INSTANCE,
			useFactory: MSALInstanceFactory
		},
		MsalService,
		MsalBroadcastService,
		{ 
			provide: OKTA_CONFIG, 
			useFactory: oktaConfigFactory,
			deps: [AppSettings]
		}
	]
})
export class MainCoreModule { }